export default class MeigaraTrendService {
  getAll() {
    return fetch("https://api.tradersr.com/api/meigaratrend")
      .then(res => res.json());
  }
}